<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.questionset-survey.text") }}</h1>

      <div role="tablist">
        <b-card no-body class=" shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.questionset-survey.line-1") }}
            </p>

            <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.line-2") }}</p>
            <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.line-3") }}</p>
            <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.line-4") }}</p>
          </b-card-body>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.questionset-survey.new.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.questionset-survey.new.line-1") }}
              </p>

              <img src="@/assets/images/help/new-question-set.png" class="image" />

              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-2')"></p>
              <img src="@/assets/images/help/question-set-form.png" class="image" />

              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-3')"></p>
              <img src="@/assets/images/help/questions.png" class="image" />

              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-4") }}</p>
              <img src="@/assets/images/help/question-form.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-5") }}</p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-6')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-7')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-8')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-9')"></p>

              <ul>
                <li>
                  <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-10") }}</p>
                </li>
                <li>
                  <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-11") }}</p>
                </li>
                <li>
                  <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-12") }}</p>
                </li>
              </ul>
              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-13')"></p>
              <img src="@/assets/images/help/question-option.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-14") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-15") }}</p>
              <img src="@/assets/images/help/question-set-questions.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-16") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-17") }}</p>
              <img src="@/assets/images/help/question-set-point.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.new.line-18") }}</p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-19')"></p>
              <img src="@/assets/images/help/question-set-enable-assessment.png" class="image" />

              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-20')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.new.line-21')"></p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>{{ $t("help.platform.questionset-survey.assignment.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.questionset-survey.assignment.line-1") }}
              </p>

              <img src="@/assets/images/help/organization-question-set.png" class="image" />

              <p class="mt-3 mb-3" v-html="$t('help.platform.questionset-survey.assignment.line-2')"></p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col3' ? 'founded' : ''" v-b-toggle.col3>
              <div>{{ $t("help.platform.questionset-survey.survey.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col3" :visible="col == 'col3'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.questionset-survey.survey.line-1") }}
              </p>
              <img src="@/assets/images/help/survey-library.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-2") }}</p>

              <img src="@/assets/images/help/admin-survey.png" class="image" />

              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-3") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-4") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-5") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-6") }}</p>
              <img src="@/assets/images/help/new-survey.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-7") }}</p>
              <img src="@/assets/images/help/in-progress-survey.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-8") }}</p>
              <img src="@/assets/images/help/survey-member.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-9") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-10") }}</p>
              <img src="@/assets/images/help/survey-result-button.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.questionset-survey.survey.line-11") }}</p>
              <img src="@/assets/images/help/survey-result.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
              <div>{{ $t("help.platform.questionset-survey.survey-answer.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.questionset-survey.survey-answer.line-1") }}
              </p>
              <p class="mb-3">
                {{ $t("help.platform.questionset-survey.survey-answer.line-2") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
